import BotAvatar from "./BotAvatar";

export default function BotMessageBox({
  children,
  assistantId,
  style,
  getInternalStyle,
}: any) {
  return (
    <div className="bot-message-row">
      <BotAvatar
        assistantId={assistantId}
        style={style}
        getInternalStyle={getInternalStyle}
      />
      <div className="bot-message-content">{children}</div>
    </div>
  );
}
